"use client"

import Link from "next/link"
import { FC, ReactNode, useState } from "react"

interface ProductButtonProps {
  children: ReactNode
  href?: string
  onClick?: () => void
  type?: "button" | "submit" | "reset"
  disabled?: boolean
  className?: string
}

export const ProductButton: FC<ProductButtonProps> = ({
  children,
  href,
  onClick,
  type = "button",
  disabled = false,
  className = "",
}) => {
  const [isHovered, setIsHovered] = useState(false)

  const buttonContent = (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => !disabled && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`
        relative
        w-full
        h-[40.4px]
        px-[18px]
        mt-4
        overflow-visible
        bg-white
        border
        border-[#333]
        hover:border-[#18AF4E]
        rounded-[4px]
        text-[#333]
        text-[16px]
        leading-[1rem]
        font-semibold
        cursor-pointer
        transition-colors
        duration-300
        disabled:opacity-50
        disabled:cursor-not-allowed
        z-[2]
        ${className}
      `}
      style={{
        opacity: disabled ? 0.5 : 1,
        color: isHovered && !disabled ? "white" : "#333",
      }}
    >
      {/* Background + Border zoom effect */}
      <span
        className="absolute top-1/2 left-1/2 pointer-events-none z-[-1] box-border"
        style={{
          backgroundColor: "#18AF4E",
          border: isHovered && !disabled ? "1px solid #18AF4E" : "1px solid #333",
          borderRadius: "4px",
          width: "100%",
          height: "100%",
          transformOrigin: "center center",
          transform: isHovered && !disabled ? "translate(-50%, -50%) scale(1)" : "translate(-50%, -50%) scale(0)",
          transition: "transform 0.3s cubic-bezier(0.6, 0, 0.1, 1)",
        }}
      />

      {/* Button text */}
      <span className="relative z-10">{children}</span>
    </button>
  )

  if (href && !disabled) {
    return (
      <Link href={href} target="_blank" className="block">
        {buttonContent}
      </Link>
    )
  }

  return buttonContent
}
